import { render, staticRenderFns } from "./editCategory.vue?vue&type=template&id=11d10b16&"
import script from "./editCategory.vue?vue&type=script&lang=js&"
export * from "./editCategory.vue?vue&type=script&lang=js&"
import style0 from "./editCategory.vue?vue&type=style&index=0&id=11d10b16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports